/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'dashboard-analytics/dataSources/services/DataSourcesService'
], function(_, Class, UpgradeBase, DataSourcesService) {
	'use strict';

	var Upgrade = Class.extend([UpgradeBase], {
		init: function() {
			this.VERSION = 1009;
		},

		/**
		 *  Upgrade dataTimeLocal Filter by setting preOrPost value for date time local filter entries to pre.
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up: function(spec) {
			this.spec = spec;
			const dataSourcesClass  = this._DataSourcesServices || DataSourcesService;
			this.dataSourcesService =  new dataSourcesClass({
				features:{
					API: this.data.dashboardApi,
					Logger: this.data.logger
				}
			});
			this.dataSourcesService.initializeSourcesCollection(this.spec);
			if (spec.widgets) {
				return this._upgradeWidgets(spec);
			}
			return Promise.resolve(spec);
		},

		_upgradeWidgets: function(spec) {
			var promises = [];
			_.each(spec.widgets, function(widget) {
				var modelRef = (widget && widget.data && widget.data.dataViews && widget.data.dataViews.length && widget.data.dataViews[0]) ? widget.data.dataViews[0].modelRef : null;
				if (modelRef && widget.localFilters && widget.localFilters.length){
					_.each(widget.localFilters, function(filterEntry){
						if(filterEntry.preOrPost !== 'pre' && _.isUndefined(filterEntry.aggregationType)){
							var promise = this._getModule(modelRef)
								.then(function(module){
									var mdc = module.getMetadataColumn(filterEntry.columnId);
									var columnDataType = mdc && mdc.getDataType();
									var usage = mdc && mdc.getType();
									if(usage && columnDataType && this.isDateType(columnDataType) && usage === 'attribute'){
										filterEntry.preOrPost = 'pre';
									}
								}.bind(this));
							promises.push(promise);
						}
					}, this);
				}
			}, this);
			return Promise.all(promises)
				.then(function(){
					return spec;
				});
		},

		isDateType: function(dataType){
			return dataType === 'date' || dataType === 'time' || dataType === 'datetime' || dataType === 'timestamp';
		},

		_getModule: function(modelRef) {
			return this.dataSourcesService.getModule(modelRef);
		},

		down: function(spec) {
			return Promise.resolve(spec);
		}
	});

	return new Upgrade();
});
